export default __webpack_public_path__ + "static/media/img-stake-wallet.f8441ca4.png";